import { action, makeObservable, observable } from 'mobx';
import { arrayMerge } from 'src/utils/formatter';
import { IToast, IToastProps } from '~/view/containers/Toasts/types/toasts';

class ToastsStore {
  constructor() {
    makeObservable(this);
  }

  @observable public toasts: IToast[] = [];

  @action public addToast(content: IToastProps) {
    this.toasts = arrayMerge(this.toasts, [{ id: content.id || `${Date.now()}`, display: true, content }], 'id');
  }

  @action public removeToast(id: string) {
    this.toasts = this.toasts.map((toast) => {
      if (toast.id === id) return { ...toast, display: false };
      return toast;
    });

    setTimeout(() => (this.toasts = this.toasts.filter((toast) => toast.id !== id)), 400);
  }
}

export const toastsStore = new ToastsStore();
